export function setPageTitle(title: string): void {
  document.title = getPageTitle(title);
}

export function getPageTitle(title: string): string {
  return title + " | Artistree";
}